var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgThumb(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 108,
    height: 109,
    viewBox: "0 0 108 109",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_939",
    "data-name": "Ellipse 939",
    cx: 54,
    cy: 54.5,
    rx: 54,
    ry: 54.5,
    transform: "translate(85.771 63.531)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_17760",
    "data-name": "Mask Group 17760",
    transform: "translate(-85.771 -63.531)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_18429",
    "data-name": "Group 18429",
    transform: "translate(95.367 77.693)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_43067",
    "data-name": "Path 43067",
    d: "M795.958,977.705l17.819-33.338a16.8,16.8,0,0,1-1.976-1.225,7.891,7.891,0,0,1-2.394-4.671,46.2,46.2,0,0,1-.609-12.953c.117-1.991-3.141-22.483-1.709-27.225.756-2.5,1.7-4.95,2.61-7.405.408-1.105.928-2.169,1.4-3.251.314-.722.093-1.295-.672-1.834a8.868,8.868,0,0,0-5.76-1.462c-3.552.176-6.138,2.048-8.212,4.761a21.672,21.672,0,0,0-4.357,13.259c-.048,3.163-.357,6.328-.678,9.479a6.708,6.708,0,0,1-1.664,3.926c-.388.425-.7.439-1.237.144-4.189-2.3-8.373-4.62-12.626-6.8-2.5-1.283-5.123-2.341-7.7-3.468a5.2,5.2,0,0,0-3.608-.14,14.893,14.893,0,0,0-6.774,3.843,3.163,3.163,0,0,0-.959,2.894c.184,1.02.312,2.05.457,3.077a2.34,2.34,0,0,1-1.055,2.433c-1.121.745-2.274,1.443-3.42,2.15-1.851,1.142-2.177,1.926-1.691,4.02.245,1.057.462,2.121.677,3.185a2.713,2.713,0,0,1-.9,2.734c-.918.811-1.8,1.675-2.776,2.406a4.047,4.047,0,0,0-1.452,4.872c.34,1.134.673,2.27,1.032,3.4a3.987,3.987,0,0,1-.352,3.536c-.374.591-.63,1.257-1.018,1.837a4.353,4.353,0,0,0-.553,3.4,19.059,19.059,0,0,0,2.359,6.193,10.619,10.619,0,0,0,3.589,3.383c2.1,1.363,4.234,2.7,6.432,3.9,2.434,1.332,4.947,2.521,7.441,3.74,1.971.963,3.964,1.883,5.952,2.813a75.036,75.036,0,0,0,10.29,3.957c4.185,1.253,8.333,2.629,12.5,3.949C794.877,977.385,795.4,977.538,795.958,977.705Z",
    transform: "translate(-745.677 -884.324)",
    fill: "#ffc98c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_43068",
    "data-name": "Path 43068",
    d: "M1032.827,1236.064q3.942-7.376,7.884-14.752a11.865,11.865,0,0,0,1.132-2.677c.187-.792.152-1.266-.113-1.41-.875-.476-4.294-.593-5.392,1.438-.462.856-.918,1.715-1.376,2.573q-7.281,13.621-14.559,27.244c-.274.514-.542,1.059-.761,1.57-.577,1.351,1.448,3.442,2.262,3.974.524.342,1.631-.553,3.008-3.146Q1028.852,1243.463,1032.827,1236.064Z",
    transform: "translate(-972.145 -1159.371)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_43069",
    "data-name": "Path 43069",
    d: "M1056.956,1241.22q4.293-8.033,8.585-16.068a4.536,4.536,0,0,0,.646-3.229,3.549,3.549,0,0,0-1.822-2.444q-4.754-2.555-9.519-5.091c-2.065-1.1-4.207-.391-5.425,1.809-.513.927-1,1.867-1.5,2.8q-7.929,14.835-15.849,29.676a6.941,6.941,0,0,0-.675,1.793,3.591,3.591,0,0,0,1.819,3.953c3.085,1.657,6.209,3.244,9.252,4.976,1.957,1.114,4.4.8,5.88-2.034C1051.174,1251.959,1054.081,1246.6,1056.956,1241.22Z",
    transform: "translate(-981.88 -1156.843)",
    fill: "#6ac47f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_43070",
    "data-name": "Path 43070",
    d: "M1146.26,1243.058a2.261,2.261,0,1,0,3.06-.928A2.261,2.261,0,0,0,1146.26,1243.058Z",
    transform: "translate(-1076.713 -1179.985)",
    fill: "#e6e6e6"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgThumb);
export default __webpack_public_path__ + "static/media/thumb.01c1c3a4b608b1c5d1f5ad0eaa4841bf.svg";
export { ForwardRef as ReactComponent };